<template>
  <div>This is analysis tab</div>
</template>

<script>
export default {};
</script>

<style></style>
